export default "__VITE_ASSET__4e419add__"